<template>
	<li :class="$style['app-aside-nav__item']">
		<RouterLink
			v-testid="`nav-item-${route.path.replace(/^\//, '')}`"
			:to="to"
			:active-class="$style['app-aside-nav__link--active']"
			:class="[
				$style['app-aside-nav__link'],
				{
					[$style['app-aside-nav__link--open']]: status === 'open',
					[$style['app-aside-nav__link--active']]: isActive
				}
			]"
		>
			<BaseIconButton
				:with-ripple="false"
				:class="$style['app-aside-nav__link-icon']"
			>
				<FontAwesomeIcon
					:icon="icon"
					size="lg"
				/>
			</BaseIconButton>
			{{ $tc(`common.titles.${route.meta.displayName}`, 2) }}
		</RouterLink>
	</li>
</template>
<script>
export default {
	props: {
		route: {
			type: Object,
			required: true
		},
		status: {
			type: String,
			required: true
		}
	},
	computed: {
		to () {
			if (this.route?.name) {
				return { name: this.route.name }
			}

			const childName = this.getFirstNamedChild(this.route?.children || [])

			if (childName) {
				return { name: childName }
			}

			return { path: this.route?.path || '/' }
		},
		isActive () {
			if (!this.route?.path) {
				return false
			}

			if (this.$route.matched.some(route => route.path === this.route.path)) {
				return true
			}

			const currentPath = this.$route.path
			const routePath = this.route.path

			return currentPath === routePath || currentPath.startsWith(routePath + '/')
		},
		icon () {
			if (this.isActive) {
				return this.route.meta.activeIcon.split(' ')
			}
			return this.route.meta.icon.split(' ')
		}
	},
	methods: {
		getFirstNamedChild (children) {
			for (const child of children) {
				if (child.name) {
					return child.name
				}

				if (child.children?.length) {
					const nestedChildName = this.getFirstNamedChild(child.children)

					if (nestedChildName) {
						return nestedChildName
					}
				}
			}

			return null
		}
	}
}
</script>
<style lang="scss" module>

.app-aside-nav {
    &__item {
        // flex: 1;
    }

    &__link {
        display: flex;
        align-items: center;
        padding: $gutter (($gutter * 2) - 2);
        margin: 0;
        text-decoration: none;
        color: getColor(helper-text);
        font-size: 14px;
        border-left: 2px solid transparent;
        transition:
            background-color 0.2s ease,
            border-left 0.2s ease,
            padding 0.2s ease,
            color 0.2s ease;
        width: 100%;
        justify-content: flex-start;
        white-space: nowrap;

        &:visited {
            color: getColor(sub-text);
        }

        &:hover {
            background-color: getColor(hover-overlay);
            color: getColor(text);
        }

        &:active {
            background-color: getColor(surface-active);
        }

        &-icon {
            margin-right: $gutter * 2.25 !important;
            color: inherit;
            transition: color 0.2s ease;

            &::before {
                content: none !important;
                height: 0;
                width: 0;
                background-color: transparent;
                position: absolute;
                border-radius: 100%;
                z-index: -1;
                transition: 0.2s ease;
            }
        }

        &--open {
            // Open state
        }

        &--active {
            color: getColor(primary);
            background-color: getColor(primary-bg-hover);
            border-left: 3px solid getColor(primary);
            padding-left: ($gutter * 2) - 3;

            &:visited {
                color: getColor(primary);
            }

            &:hover {
                background-color: getColor(primary-bg-hover);
                color: getColor(primary-hover);
            }

            .app-aside-nav__link-icon {
                color: getColor(primary);
            }
        }
    }
}

</style>
